const EXPORT_TYPE = {
  SALESFORCE: "SALESFORCE",
  INFO: "INFO",
  ALL_FIELD: "ALL_FIELD"
};

export default EXPORT_TYPE
